<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="text-white bg-blue" inline-actions>
        فاکتور
        <q-badge align="top" color="red" text-color="white" class="q-ml-xs">{{ saleNum }}</q-badge>
        <q-chip icon="person" :label="factorInfo.Cs_Name " square clickable @click="showCustomerInfo"/>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding" v-if="returnDocument">
      <q-chip square color="red-10" text-color="white" icon="tag" label="برگشتی"/>
    </q-card-section>
    <q-card-section class="no-padding" v-if="!returnDocument">
      <q-toggle
          v-if="saleState===0"
          color="green-14" class="text-subtitle2"
          v-model="Sale_Tax_State"
          :label="Sale_Tax_State===false?'ارزش افزوده در نظر گرفته نشود':'ارزش افزوده در نظر گرفته شود'"/>
    </q-card-section>
    <q-card-section class="no-padding text-center" v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v)) && !returnDocument" >
      <q-chip color="indigo" text-color="white" square v-for="(item,index) in groupedList" :key="index"
              :label="item.Group_Name">
        <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                 :label="`${item.sum.toLocaleString()} ریال`"/>
        <q-badge v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))" class="q-ml-sm"
                 :color="item.sum>0?'green':'red'" text-color="white"
                 :label="`سود: ${parseInt(item.profit.toFixed(0)).toLocaleString()} ریال`"/>
        <q-tooltip v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))"
                   content-class="bg-transparent">
          <q-chip text-color="white" color="indigo" square label="فروش">
            <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                     :label="`${item.sum.toLocaleString()} ریال`"/>
          </q-chip>
          <q-space/>
          <q-chip text-color="white" color="indigo" square label="خرید">
            <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                     :label="`${(item.sum - item.profit).toLocaleString()} ریال`"/>
          </q-chip>

        </q-tooltip>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-input filled label="جستجو در لیست" v-model="filter"/>
      <q-table
          :data="lodash.sortBy(factorItems, ['Group_Name', 'Goods_Name'])"
          row-key="Sale_Num"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :filter="filter"
          :hide-bottom="!$q.screen.lt.md"
          :rows-per-page-options="[0]">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td class="text-center">کد کالا</td>
            <td class="text-center">نام کالا</td>
            <td class="text-center">تعداد</td>
            <td class="text-center">واحد</td>
            <td class="text-center">قیمت لیست</td>
            <td class="text-center">قیمت واحد</td>
            <td class="text-center">قیمت کل</td>
            <td class="text-center">تخفیف</td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v)) && !returnDocument">مبلغ
              واحد خرید روز
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument">
              مبلغ کل خرید روز
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v)) && !returnDocument">مبلغ
              واحد خرید اصلی
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument">
              مبلغ کل خرید اصلی
            </td>
            <td class="text-center"
                v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))  && !returnDocument">سود فروش
            </td>
          </q-tr>
          <q-tr class="bg-indigo text-white text-center">
            <td>{{ factorItems.length }} قلم</td>
            <td></td>
            <td>{{ lodash.sumBy(factorItems, "SaleG_Count")}}</td>
            <td></td>
            <td></td>
            <td></td>
            <td> {{ lodash.sumBy(factorItems, "SaleG_TotalAll").toLocaleString() }}</td>
            <td></td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v)) && !returnDocument">
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument">
              {{
                parseInt(lodash.sumBy(factorItems, item => item.SaleG_Count * item.BuyDay_Price).toFixed(0)).toLocaleString()
              }}
            </td>

            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v)) && !returnDocument">
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument">
              {{
                parseInt(lodash.sumBy(factorItems.filter(record => record.BuyLast_Price), item => item.SaleG_Count * item.BuyLast_Price).toFixed(0)).toLocaleString()
              }}
            </td>

            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument">
              <q-badge
                  text-white
                  :color="lodash.sumBy(factorItems, item=> (item.SaleG_TotalAll - (item.SaleG_Count *  item.BuyDay_Price)))?'green':'red'"
                  :label=" parseInt(lodash.sumBy(factorItems, item=> (item.SaleG_TotalAll - (item.SaleG_Count *  item.BuyDay_Price))).toFixed(0)).toLocaleString()">
              </q-badge>
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center" v-if="!$q.screen.lt.md">
            <td>
              <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                      v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                      :label="props.row.Goods_Code"/>
            </td>
            <td class="text-left">
              {{ props.row.Goods_Name }}
              <q-space/>
              <q-chip square dense :label="props.row.Group_Name"/>
            </td>
            <td>
              <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.SaleG_Count }}
              </q-badge>
            </td>
            <td>
              <q-badge color="brown" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.Unit_Name }}
              </q-badge>
            </td>
            <td>
              <q-badge color="teal" class="q-ml-xs">{{ props.row.List_Price | toLoalString }} ریال
              </q-badge>
            </td>
            <td>
              <q-badge color="teal" class="q-ml-xs">{{ props.row.SaleG_PricePure | toLoalString }} ریال
              </q-badge>
              <q-btn v-if="$store.state.roles.some(v=>['admin','can_edit_factor_price'].includes(v)) && saleState===0"
                     icon="edit"
                     flat round size="sm" text-color="indigo" class="q-ml-xs">
                <q-popup-edit
                    persistent
                    buttons
                    v-model="props.row.SaleG_PricePure"
                    @save="(val, initialValue) => updateSaleGPrice(val, initialValue, props.row)"
                >
                  <q-field
                      v-model="props.row.SaleG_PricePure"
                      mask="currency"
                      label="مبلغ فروش"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      lazy-rules
                      :rules="[
                                           val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ فروش را وارد نمایید',
                                           val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ فروش عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                         ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value)"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                  </q-field>
                </q-popup-edit>
              </q-btn>
            </td>
            <td>
              <q-badge color="teal-14" class="q-ml-xs">{{ props.row.SaleG_TotalAll | toLoalString }}
                ریال
              </q-badge>
            </td>
            <td v-if="props.row.Goods_Code!=='109991'">
              <q-badge color="red" text-color="white" :label="`${props.row.SaleG_Off_D_Origin} %`"/>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'">
              <q-badge color="indigo" class="q-ml-xs">
                {{ props.row.BuyDay_Price | toLoalString }} ریال
              </q-badge>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'">
              <q-badge color="indigo-14" class="q-ml-xs">
                {{ props.row.SaleG_Count * props.row.BuyDay_Price | toLoalString }}
                ریال
              </q-badge>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'">
              <q-badge color="indigo" class="q-ml-xs">
                {{ props.row.BuyLast_Price | toLoalString }} ریال
              </q-badge>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'">
              <q-badge color="indigo-14" class="q-ml-xs">
                {{ props.row.SaleG_Count * props.row.BuyLast_Price | toLoalString }}
                ریال
              </q-badge>
            </td>

            <td v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'">
              <q-chip dense square color="blue-10" text-color="white"
                      :label=" parseInt(props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price).toFixed((0))).toLocaleString()">
                <q-badge
                    class="q-ml-xs"
                    :color="(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2) > 0 ?'green':'red'"
                    text-color="white"
                    :label="`${(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2)} %`"/>
              </q-chip>
              ریال
            </td>
          </q-tr>
          <q-tr :props="props" class="my-class" v-if="$q.screen.lt.md">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                          v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                          :label="props.row.Goods_Code"/>
                </q-card-section>
                <q-card-section class="no-padding">
                  {{ props.row.Goods_Name }}
                  <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                    {{ props.row.SaleG_Count }}
                  </q-badge>
                  <q-badge color="brown" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                    {{ props.row.Unit_Name }}
                  </q-badge>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-chip :size="$q.screen.lt.md?'md':'md'" color="blue"
                          text-color="white" square flat
                          label="قیمت واحد" v-if="props.row.Goods_Code!=='109991'">
                    <q-badge color="red" class="q-ml-xs">{{ props.row.SaleG_PricePure | toLoalString }} ریال
                    </q-badge>
                    <q-btn
                        v-if="$store.state.roles.some(v=>['admin','can_edit_factor_price'].includes(v)) && saleState===0"
                        icon="edit"
                        flat round size="sm" text-color="white" class="q-ml-xs">
                      <q-popup-edit
                          persistent
                          buttons
                          v-model="props.row.SaleG_PricePure"
                          @save="(val, initialValue) => updateSaleGPrice(val, initialValue, props.row)"
                      >
                        <q-field
                            v-model="props.row.SaleG_PricePure"
                            mask="currency"
                            label="مبلغ فروش"
                            label-color="indigo"
                            autofocus
                            dir="ltr"
                            lazy-rules
                            :rules="[
                                           val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ فروش را وارد نمایید',
                                           val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ فروش عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                                         ]">
                          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                            <input :id="id" class="q-field__native text-right" :value="value"
                                   @change="e => emitValue(e.target.value)"
                                   v-money="moneyFormatForDirective"
                                   v-show="floatingLabel">
                          </template>
                        </q-field>
                      </q-popup-edit>
                    </q-btn>
                  </q-chip>
                  <q-chip v-if="props.row.SaleG_TotalAll>0" :size="$q.screen.lt.md?'md':'md'" square color="indigo"
                          text-color="white" flat
                          label="قیمت کل">
                    <q-badge color="red-14" class="q-ml-xs">{{ props.row.SaleG_TotalAll | toLoalString }}
                      ریال
                    </q-badge>
                  </q-chip>
                  <q-chip v-if="props.row.SaleG_Off_D_Origin && props.row.SaleG_Off_D_Origin>0" square color="indigo"
                          text-color="white" icon="trending_down" label="تخفیف">
                    <q-badge color="red" text-color="white" :label="`${props.row.SaleG_Off_D_Origin} %`"/>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-chip :size="$q.screen.lt.md?'md':'md'" color="blue"
                          text-color="white" square flat
                          label="مبلغ واحد خرید روز"
                          v-if="props.row.Goods_Code!=='109991' && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'">
                    <q-badge color="red" class="q-ml-xs">{{ props.row.BuyDay_Price | toLoalString }} ریال
                    </q-badge>
                  </q-chip>
                  <q-chip
                      v-if="props.row.SaleG_TotalAll>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'"
                      :size="$q.screen.lt.md?'md':'md'" square color="indigo"
                      text-color="white" flat
                      label="مبلغ کل خرید روز">
                    <q-badge color="red-14" class="q-ml-xs">
                      {{ props.row.SaleG_Count * props.row.BuyDay_Price | toLoalString }}
                      ریال
                    </q-badge>
                  </q-chip>
                  <q-chip
                      v-if="props.row.SaleG_TotalAll>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'"
                      square color="indigo"
                      text-color="white" icon="trending_up" label="سود فروش">
                    <q-badge
                        text-color="white"
                        :color="(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2) > 0 ?'green':'red'"
                        :label="`${ parseInt((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price)).toFixed(0)).toLocaleString()}`"/>
                  </q-chip>
                  <q-chip
                      v-if="props.row.SaleG_TotalAll>0 && $store.state.roles.some(v=>['admin','see_profit'].includes(v))  && !returnDocument && props.row.Goods_Code!=='109991'"
                      square color="indigo"
                      text-color="white" icon="trending_up" label="درصد سود فروش">
                    <q-badge
                        :color="(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2) > 0 ?'green':'red'"
                        text-color="white"
                        :label="`${(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2)} %`"/>
                  </q-chip>

                </q-card-section>
                <q-card-section v-if="props.row.Sale_State===0">
                  <q-toggle @input="changeViewSaleGOffState(props.row)" color="red-14" class="text-subtitle2"
                            v-model="props.row.Can_See_Off_Value"
                            :label="props.row.Can_See_Off_Value===false?'تخفیف در چاپ نمایش داده نشود':'تخفیف در چاپ نمایش داده شود'"/>
                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="showProductDetails">
      <PDetails :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "FactorDetails",
  components: {
    PDetails: () => import("@/components/productInfo/ProductDetail.vue")
    , CustomerInfo},
  props: {
    saleNum: {
      type: Number,
    },
    saleKind: {
      type: Number,
    },
    saleState: {
      type: Number,
      required: true,
    },
    factorItems: {},
  },
  data() {
    return {
      showProductDetails: false,
      selectedProductDetails: [],
      groupedList: [],
      selectedCustomer: '',
      customerInfoDialog: false,
      factorInfo: '',
      returnDocument: this.factorItems.filter(item => item.Sale_Kind === 1).length === 0,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      Sale_Tax_State: false,
      filter: '',
    }
  },
  watch: {
    Sale_Tax_State: function () {
      this.SetFactorTax({
        Sale_Num: this.saleNum,
        Sale_Tax_State: this.Sale_Tax_State ? 1 : 0
      }).then(() => {
        this.$q.notify({
          type: 'position',
          color: 'positive',
          position: 'top',
          message: 'تغییرات درخواستی ارزش افزوده اعمال گردید'
        })
      })
    }
  },
  methods: {
    ...mapActions({
      SetFactorViewSaleGOffState: 'Orders/SetFactorViewSaleGOffState',
      SetFactorTax: 'Orders/SetFactorTax',
      changeFactorItemPrice: 'Orders/changeFactorItemPrice',
      getFactorInfo: 'Orders/getFactorInfo',
      getCustomerInfo: 'Customers/get_customer_info',
      getProductInfo: 'Products/getProductInfo'
    }),
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
    updateSaleGPrice(val, initialValue, row) {
      let discountValue;
      if (this.$store.state.roles.some(v => ['admin', 'can_use_open_price'].includes(v))) {
        discountValue = 0.50
      } else {
        discountValue = 0.1
      }
      if (parseInt(val.toString().replaceAll(',', '')) < (parseInt(row.BuyDay_Price) - (parseInt(row.BuyDay_Price) * (discountValue)))) {
        this.$q.notify({
          message: `امکان کاهش فروش کمتر از ${(discountValue) * 100} درصد خرید روز میسر نمی باشد!`,
          color: 'deep-orange',
          position: 'top',
          type: 'negative'
        });
        row.SaleG_PricePure = initialValue
      } else {
        row.SaleG_Pay = parseInt(row.SaleG_Count) * val
        row.SaleG_TotalAll = parseInt(row.SaleG_Count) * val
        this.changeFactorItemPrice({
          saleNum: this.saleNum,
          GoodsId: row.Goods_ID,
          newPrice: row.SaleG_PricePure.toString().replaceAll(',', '')
        }).then((res) => {
          this.$q.notify({
            message: `مبلغ فروش کالا تغییر داده شد`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.SaleG_TotalAll = eval(res.items)[0].SaleG_TotalAll
        }).catch((err) => {
          if (err.response.data.result) {
            this.$q.notify({
              message: `به دلیل سند شدن فاکتور امکان تغییر قیمت آن میسر نمی باشد`,
              color: 'negative',
              position: 'top',
              type: 'negative'
            });
          }
          row.SaleG_PricePure = initialValue
          row.SaleG_TotalAll = parseInt(row.SaleG_Count) * initialValue
        })
      }
    },
    changeViewSaleGOffState: function (row) {
      this.SetFactorViewSaleGOffState(row);
    },
    changeTaxState: function (row) {
      this.SetFactorTax(row);
    },
    showCustomerInfo() {
      this.getCustomerInfo(this.factorInfo.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
  },
  created() {
    this.getFactorInfo({
      saleNum: this.saleNum,
      saleKind: this.factorItems.filter(item => item.Sale_Kind === -1).length === 0 ? 1 : -1
    }).then((res) => {
      this.factorInfo = res[0]
      this.Sale_Tax_State = this.factorItems.filter(item => item.SaleG_Tax_D === 0).length === 0;
    });

    this.groupedList = this.lodash(this.factorItems).filter(item => item.Goods_Group !== 86).groupBy('Group_Name')
        .map(function (items, Group_Name) {
          return {
            Group_Name: Group_Name,
            sum: items.map(item => item.SaleG_TotalAll).reduce((accumulator, curr) => accumulator + curr),
            profit: items.map(item => (item.SaleG_TotalAll - (item.SaleG_Count * item.BuyDay_Price))).reduce((accumulator, curr) => accumulator + curr)
          };
        }).value();
  }
}
</script>

<style scoped>

</style>